// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1qHpK","subheader":"ReorderModal_subheader__VQlZq","listWrap":"ReorderModal_listWrap__2VO1R"};